<template>
  <WdsMenu placement="bottom-end" z-index="10" global>
    <template #trigger>
      <WdsButtonGhost primary class="tw-max-w-[100px] tw-relative">
        <WdsIcon name="overflow-menu-horizontal" :size="18" />
      </WdsButtonGhost>
    </template>
    <WdsMenuOption :href="`/bills/${paymentRequest.localId}/edit`">
      <WdsIcon name="edit" :size="16" />
      {{ $t('Edit') }}
    </WdsMenuOption>
    <WdsMenuOption theme="DESTRUCTIVE" @click="showDeletePaymentRequestModal = true">
      <WdsIcon name="trash-can" :size="16" />
      {{ $t('Delete') }}
    </WdsMenuOption>
  </WdsMenu>

  <DeletePaymentRequestModal
    :open="showDeletePaymentRequestModal"
    :payment-request-id="paymentRequest.publicId"
    @close="showDeletePaymentRequestModal = false"
    @payment-request-deleted="$emit('payment-request-deleted')"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { WdsButtonGhost, WdsIcon, WdsMenu, WdsMenuOption } from '@worksome/wds-components'

import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import DeletePaymentRequestModal from '@/components/PaymentRequest/DeletePaymentRequestModal.vue'

defineProps<{
  paymentRequest: any
}>()

defineEmits(['payment-request-deleted'])

const showDeletePaymentRequestModal = ref(false)
</script>
